import { Icon } from "@mui/material";

export default function ImgIcon({ size, alt, ...props }) {
    return (
        <Icon sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img height={size} width={size} alt={alt} {...props} />
        </Icon>
    );
}